module.exports = __webpack_public_path__ + "img/2d.e1672660.png";